<template>
  <v-dialog
    v-model="showDialogForm"
    persistent
    max-width="600px"
  >
    <v-card v-if="isCustomerDefined">
      <v-card-title>
        <span class="headline">{{ $t("Subscriber") }}</span>
      </v-card-title>
      <v-card-text>
        <SubscriberForm
          :errors="violations"
          :values="item"
          :loading="$apollo.loading"
          :current-subscribers="currentSubscribers"
          :current-customer="currentCustomer"
          ref="subscriberDialogForm"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          @click="showDialogForm = false"
        >{{ $t("Close") }}</v-btn>
        <v-spacer />
        <v-btn
          class="mainAccent lighten-3"
          @click="resetForm"
        >{{ $t("Reset") }}</v-btn>
        <v-btn
          color="primary"
          @click="sendForm"
        >{{ $t("Submit") }}</v-btn>
      </v-card-actions>
    </v-card>
    <Loading :visible="$apollo.loading" />
  </v-dialog>
</template>

<script>
  import gql from 'graphql-tag'
  import SubscriberForm from "./Form";
  import NotificationMixin from "../../mixins/NotificationMixin";
  import Loading from "@/components/Loading";
  import TenantMixin from "@/mixins/TenantMixin";
  import CustomerMixin from "@/mixins/CustomerMixin";
  import SubscriptionUpdate from "@/views/subscription/Update.vue";

  const servicePrefix = "Subscriber";

  export default {
    name: "SubscriberDialog",
    servicePrefix,
    mixins: [NotificationMixin, TenantMixin, CustomerMixin],
    components: {
      Loading,
      SubscriberForm
    },
    props: {
      value: Boolean,
      handleCreated: {
        type: Function,
        required: false,
      },
      subscriberItem: {
        type: Object,
        required: false,
      },
      subscriptionId: {
        type: String,
        required: true,
      },
      currentSubscribers: {
        type: Array,
        required: false,
      }
    },
    data() {
      return {
        item: {},
        showDiscountDialogForm: false,
        createMessage: this.$t('SubscriberAdded'),
        updateMessage: this.$t('SubscriberUpdated'),
        violations: {},
      };
    },
    computed: {
      showDialogForm: {
        get() {
          return this.value;
        },
        set(value) {
          if (!value) {
            this.$emit("close");
          }
        },
      },
      currentCustomer() {
        if (this.item.customer) {
          return this.resolveCustomer(this.item.customer)
        }
        return null;
      },
      isCustomerDefined() {
        return typeof this.currentCustomer !== 'undefined';
      }
    },
    methods: {
      sendForm() {
        if (this.isValidForm()) {
          let model = this.$refs.subscriberDialogForm.$v.item.$model;
          if (this.handleCreated && false === 'id' in model) {
            model["subscription"] = this.subscriptionId;
            this.addSubscriber(model);
          }
        }
      },
      reset() {
        this.$refs.subscriberDialogForm.$v.$reset();
      },
      resetForm() {
        this.item = { ...this.subscriberItem };
        if (this.$refs["subscriberDialogForm"]) {
          this.$refs.subscriberDialogForm.$v.$reset();
        }
      },
      isValidForm() {
        this.$refs.subscriberDialogForm.$v.$touch();
        return !this.$refs.subscriberDialogForm.$v.$invalid;
      },
      addSubscriber(addSubscriberInput) {
        this.violations = {};
        this.$apollo.mutate({
          mutation: gql`mutation ($input: createSubscriberInput!) {
            createSubscriber(input: $input) {
              subscriber{
                ...subscriber
              }
            }
          }
          ${SubscriptionUpdate.fragments.subscriber}
          `,
          variables: {
            input: addSubscriberInput,
          },
          context: {
            headers: {
              authorization: this.$store.state.authentication.loggedIn ? `Bearer ${this.$store.state.authentication.token}` : ''
            }
          }
        }).then((data) => {
          this.showMessage(this.createMessage);
          if (this.handleCreated) {
            this.handleCreated(data.data.createSubscriber.subscriber);
            this.showDialogForm = false;
          }
        }).catch((error) => {
          error.graphQLErrors.forEach((error) => {
            error.extensions.violations.forEach(v => {
              Object.assign(this.violations, {[v.path]: v.message})
            });
          });
          if(this.violations && 'customer' in this.violations) {
            this.showError('Kunde ist bereits vorhanden.');
          }
        });
      }
    },
    watch: {
      subscriberItem() {
        this.item = { ...this.subscriberItem };
        this.resetForm();
      },
      error(message) {
        message && this.showError(message);
      },
    },
    created() {
      this.item = { ...this.subscriberItem };
    },
  };
</script>
